import { CSSProperties } from "react";
import { theme } from "./theme";

export const styles: Record<string, CSSProperties> = {
    customCardSingle: {
        display: "block",
        height: "100%",
        minHeight: 0,
    },
    mainCard: {
        minWidth: 0,
        height: "100%",
        minHeight: 0,
        padding: 0,
        background: "transparent",
        borderRadius: 0,
        border: "none",
        boxShadow: "none",
        display: "flex",
        flexDirection: "column",
    },
    controlsRow: {
        display: "flex",
        alignItems: "center",
        gap: "0.8rem",
        flexWrap: "wrap",
        marginBottom: 0,
        minHeight: "2.65rem",
        padding: "0 0.82rem",
        borderBottom: `1px solid ${theme.borderSoft}`,
        flexShrink: 0,
    },
    separator: {
        color: theme.fgMuted,
        fontWeight: 700,
    },
    contentLayout: {
        display: "block",
        marginBottom: 0,
        flex: 1,
        minHeight: 0,
    },
    selectionGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        gap: 0,
        height: "100%",
        minHeight: 0,
    },
    selectionPanel: {
        border: "none",
        borderRadius: 0,
        background: "transparent",
        height: "auto",
        minHeight: 0,
        padding: "0.78rem 0.82rem",
        display: "flex",
        flexDirection: "column",
        boxShadow: "none",
    },
    panelHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "0.55rem",
        flexWrap: "wrap",
        marginBottom: "0.5rem",
        flexShrink: 0,
    },
    panelTitle: {
        color: theme.fgStrong,
        fontWeight: 800,
        fontSize: "0.95rem",
        lineHeight: 1.2,
    },
    panelSubTitle: {
        color: theme.fgMuted,
        fontSize: "0.79rem",
        fontWeight: 700,
        marginTop: "0.12rem",
        lineHeight: 1.45,
    },
    panelTools: {
        display: "flex",
        alignItems: "center",
        gap: "0.4rem",
        flexWrap: "wrap",
        justifyContent: "flex-end",
    },
    summaryChip: {
        border: `1px solid ${theme.borderStrong}`,
        borderRadius: "999px",
        background: theme.bgChip,
        color: theme.brandDeep,
        padding: "0.18rem 0.56rem",
        fontSize: "0.76rem",
        fontWeight: 800,
        whiteSpace: "nowrap",
    },
    toolBtn: {
        border: `1px solid ${theme.borderStrong}`,
        borderRadius: "6px",
        padding: "0.36rem 0.62rem",
        fontSize: "0.79rem",
        fontWeight: 800,
        background: theme.bgControl,
        color: theme.brandDeep,
        cursor: "pointer",
    },
    checkListBox: {
        border: "none",
        borderTop: `1px solid ${theme.borderSoft}`,
        borderRadius: 0,
        background: "transparent",
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        padding: "0.42rem 0 0",
    },
    checkRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: "0.46rem",
        padding: "0.38rem 0.44rem",
        borderRadius: "9px",
        cursor: "pointer",
        border: "1px solid transparent",
    },
    checkRowActive: {
        display: "flex",
        alignItems: "flex-start",
        gap: "0.46rem",
        padding: "0.38rem 0.44rem",
        borderRadius: "9px",
        cursor: "pointer",
        border: `1px solid ${theme.borderStrong}`,
        background: theme.bgSelectionActive,
    },
    checkInput: {
        marginTop: "0.08rem",
        accentColor: "var(--brand-500)",
    },
    checkText: {
        color: theme.fgStrong,
        fontSize: "0.82rem",
        fontWeight: 600,
        wordBreak: "break-all",
        lineHeight: "1.25",
    },
    duplicateBadge: {
        marginLeft: "auto",
        fontSize: "0.71rem",
        fontWeight: 800,
        color: "var(--brand-700)",
        background: theme.bgSelectionActive,
        borderRadius: "999px",
        padding: "0.11rem 0.42rem",
        whiteSpace: "nowrap",
    },
    checkGroupHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "0.55rem",
        padding: "0.34rem 0.48rem",
        borderRadius: 0,
        color: theme.fgMuted,
        background: "transparent",
        border: "none",
        borderBottom: `1px solid ${theme.borderSoft}`,
        fontSize: "0.75rem",
        fontWeight: 900,
        letterSpacing: "0",
    },
    checkGroupCount: {
        color: theme.brandDeep,
        fontSize: "0.72rem",
        fontWeight: 900,
    },
    emptyText: {
        color: theme.fgMuted,
        fontSize: "0.83rem",
        fontWeight: 600,
        padding: "0.5rem",
    },
    emptyState: {
        minHeight: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.35rem",
        padding: "1rem",
        textAlign: "center",
    },
    emptyStateTitle: {
        color: theme.fgStrong,
        fontSize: "0.88rem",
        fontWeight: 800,
        lineHeight: 1.35,
    },
    emptyStateDescription: {
        color: theme.fgMuted,
        fontSize: "0.78rem",
        fontWeight: 600,
        lineHeight: 1.45,
        maxWidth: "24rem",
    },
    duplicateListBox: {
        display: "flex",
        flexDirection: "column",
        gap: "0.68rem",
        border: `1px solid ${theme.borderStrong}`,
        borderRadius: "11px",
        background: theme.bgControl,
        padding: "0.72rem",
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
    },
    duplicateRow: {
        display: "flex",
        flexDirection: "column",
        gap: "0.55rem",
        alignItems: "stretch",
        padding: "0.7rem 0.8rem",
        borderRadius: "12px",
        border: `1px solid ${theme.borderSoft}`,
        background: theme.bgPanel,
    },
    duplicatePathWrap: {
        display: "flex",
        alignItems: "flex-start",
        gap: "0.48rem",
        minWidth: 0,
    },
    duplicateIndex: {
        flexShrink: 0,
        minWidth: "1.85rem",
        height: "1.5rem",
        borderRadius: "999px",
        background: theme.bgSelectionActive,
        color: theme.brandDeep,
        fontWeight: 800,
        fontSize: "0.75rem",
        lineHeight: "1.5rem",
        textAlign: "center",
    },
    duplicatePath: {
        color: theme.fgStrong,
        fontSize: "0.84rem",
        wordBreak: "normal",
        overflowWrap: "anywhere",
        lineHeight: "1.4",
        minWidth: 0,
    },
    duplicateSelect: {
        borderRadius: "10px",
        border: `1px solid ${theme.borderStrong}`,
        background: theme.bgControlMuted,
        color: theme.fgStrong,
        fontSize: "0.79rem",
        padding: "0.48rem 0.68rem",
        minWidth: 0,
        width: "100%",
    },
    duplicateModalOverlay: {
        position: "fixed",
        inset: 0,
        padding: "1.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(15, 23, 42, 0.46)",
        zIndex: 3000,
        overflow: "hidden",
    },
    duplicateModalDialog: {
        width: "min(820px, calc(100vw - 2rem))",
        maxHeight: "min(760px, calc(100vh - 2rem))",
        padding: "1rem",
        borderRadius: "16px",
        border: `1px solid ${theme.borderSoft}`,
        background: theme.bgSurface,
        boxShadow: theme.shadowSoft,
        display: "flex",
        flexDirection: "column",
        minHeight: "320px",
        position: "relative",
        zIndex: 1,
    },
    duplicateModalHeaderActions: {
        display: "flex",
        alignItems: "center",
        gap: "0.45rem",
        flexWrap: "wrap",
        justifyContent: "flex-end",
    },
    duplicateCloseBtn: {
        border: `1px solid ${theme.borderStrong}`,
        borderRadius: "9px",
        padding: "0.42rem 0.72rem",
        fontSize: "0.77rem",
        fontWeight: 700,
        background: theme.bgControl,
        color: theme.fgStrong,
        cursor: "pointer",
    },
    modalFooter: {
        display: "flex",
        justifyContent: "flex-end",
        gap: "0.6rem",
        marginTop: "0.9rem",
        flexWrap: "wrap",
    },
    modalSecondaryButton: {
        border: `1px solid ${theme.borderStrong}`,
        borderRadius: "10px",
        padding: "0.62rem 1rem",
        fontSize: "0.82rem",
        fontWeight: 700,
        background: theme.bgControl,
        color: theme.fgStrong,
        cursor: "pointer",
    },
    modalPrimaryButton: {
        border: "none",
        borderRadius: "10px",
        padding: "0.62rem 1rem",
        fontSize: "0.82rem",
        fontWeight: 800,
        background: "linear-gradient(135deg, var(--brand-700) 0%, var(--brand-500) 100%)",
        color: "#fff",
        boxShadow: "0 10px 22px rgba(79, 70, 229, 0.22)",
        cursor: "pointer",
    },
    versionTypeText: {
        marginBottom: "0.5rem",
        color: theme.fgMuted,
        fontSize: "0.84rem",
        fontWeight: 700,
        flexShrink: 0,
    },
    dateInput: {
        padding: "0.52rem 0.68rem",
        borderRadius: "10px",
        border: `1px solid ${theme.borderStrong}`,
        background: theme.bgControlMuted,
        color: theme.fgStrong,
        minWidth: "128px",
        outline: "none",
        fontSize: "0.84rem",
        fontWeight: 700,
    },
    extractActions: {
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
        gap: "0.65rem",
        width: "100%",
        padding: "0.72rem 0.82rem 0",
        borderTop: `1px solid ${theme.borderSoft}`,
        flexShrink: 0,
    },
    extractBtn: {
        width: "100%",
        background: "var(--brand-500)",
        color: "#fff",
        padding: "0.64rem",
        border: "none",
        borderRadius: "6px",
        fontWeight: 800,
        letterSpacing: 0,
        boxShadow: "none",
        cursor: "pointer",
        flexShrink: 0,
    },
    transferBtn: {
        width: "100%",
        padding: "0.64rem",
        border: "1px solid var(--brand-500)",
        borderRadius: "6px",
        color: "var(--brand-700)",
        background: "var(--control-bg)",
        fontWeight: 800,
        letterSpacing: 0,
        cursor: "pointer",
        flexShrink: 0,
    },
};
